import http from "./http"
var qs = require('qs');
export const getTopicAdvPage = (params) => {
    const url = `/topic/getTopicAdvPage`
    return http({
        url:url,
        method:'post',
        params
    })
  }

  ///topic/getQrCode 请求方式：post
  export const getQrCode = (params) => {
    window.console.log(params,'565656565')
    const url = `/topic/getQrCode`
    return http({
        url:url,
        method:'post',
        params
    })
  }
